import styled from "styled-components";

export const Container = styled.div`
  .postage-fee-list {
    margin-top: 32px;
    left-top: 32px;
  }
`;
